import * as Schema from "effect/Schema"

export const ServerNotification = Schema.Struct({
    type: Schema.String,
    data: Schema.Unknown,
})
export type ServerNotification = typeof ServerNotification.Type
